import React from 'react';
import { PricingCards } from './PricingCards';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/50 border-t border-dark-border relative overflow-hidden" data-id="element-89">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-90" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-91">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-92">
          Comienza hoy tu viaje por el Imperio Romano
        </h2>
        <p className="text-lg md:text-xl text-text-secondary mb-12 max-w-3xl mx-auto" data-id="element-93">
          Miles de años después, los emperadores, batallas y misterios de Roma
          siguen despertando la curiosidad de millones de personas. Ahora puedes
          descubrirlos en una colección completa, diseñada para aprender,
          disfrutar y sorprenderte con una de las civilizaciones más influyentes
          de todos los tiempos.
        </p>

        <PricingCards data-id="element-94" />

        <div className="mt-16 mb-12" data-id="element-95">
          <p className="text-xl md:text-2xl font-heading font-bold text-gold-light italic max-w-4xl mx-auto" data-id="element-96">
            "La historia no solo se estudia. Se vive, se descubre y se recuerda.
            Imperio Romano Legendario es una invitación a recorrer una de las
            civilizaciones más fascinantes de todos los tiempos."
          </p>
        </div>

        <div className="mt-8 flex flex-wrap justify-center items-center gap-6 md:gap-8 text-sm md:text-base text-gray-400" data-id="element-97">
          <div className="flex items-center gap-2" data-id="element-98">
            <Lock className="w-5 h-5 text-gold" data-id="element-99" />
            <span data-id="element-100">Pago 100% seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-101">
            <Zap className="w-5 h-5 text-gold" data-id="element-102" />
            <span data-id="element-103">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-104">
            <Shield className="w-5 h-5 text-gold" data-id="element-105" />
            <span data-id="element-106">Garantía 7 días</span>
          </div>
        </div>
      </div>
    </section>;
}